import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import BlogForm from "./AddBlog";

export default function EditBlog() {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <BlogForm
      isEdit={true}
      blogId={id}
      onSuccess={() => navigate("/listblogs")}
    />
  );
}